<template>
  <div>
    <div class="card_wrap">
      <div class="label" />
      <a class="card_image" :href="routeUserLink(hub.alias)" :title="hub.name">
        <img class="lazyload" :data-src="hub.logo_url ? hub.logo_url : contentCloudFrontWithVersion('/avgl_default_event_icon.png')">
      </a>
      <div class="card_properties">
        <div class="hub-name" :title="hub.name"><a :href="routeUserLink(hub.alias)">{{ hub.name }}</a></div>
      </div>
      <a class="checkout_btn" :href="routeUserLink(hub.alias)" target="_blank">Check it out!</a>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';

export default {
  components: {},
  mixins: [component],
  props: {
    hub: {
      type: Object,
      default() {
        return {

        };
      },
    },
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>
